<template>
  <el-form ref="formValidate"
           :model="params"
           inline
           label-width="80px">
    <el-form-item label=""
                  prop="roleName">
      <el-tree ref="roleTree"
               :data="tempData"
               :props="defaultProps"
               node-key="id"
               show-checkbox
               default-expand-all></el-tree>
    </el-form-item>
  </el-form>
</template>
<script>
import { allotRoleByUserId } from '../../../services/user.js'
export default {
  name: 'zk-user-allot-role',
  props: ['roleData', 'roleArr', 'userId'],
  data () {
    let defaultProps = {
      children: 'roleList',
      label: 'name'
    }
    let tempData = []
    return {
      defaultProps,
      params: {},
      tempData
    }
  },
  methods: {
    save () {
      let self = this
      self.params = {
        userId: this.userId,
        roleArr: this.$refs.roleTree.getCheckedKeys(true)
      }
      return new Promise((resolve, reject) => {
        resolve(allotRoleByUserId(self.params))
      })
    }
  },
  watch: {
    roleData (val) {
      this.tempData = [{
        name: `${this.$t('user.roleManagement')}`, // 角色管理 this.$('user.roleManagement')
        id: 'roleTree',
        roleList: this.roleData
      }]
    },
    roleArr (val) {
      this.$refs.roleTree.setCheckedKeys(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/userAllotRole/src/main.vue